// One definition of "mobile", read live.
//
// This used to be three: App.tsx's resize listener, a snapshot on the slider
// store written only when a template arrived, and a `.mobile` class the booking
// CSS depended on entirely. The store copy was the dangerous one — it never
// updated on resize, so a phone could keep a desktop layout and the booking
// panel's fixed 300px rail would blow out a 375px viewport with no media query
// underneath to catch it.
//
// The rule now: CSS owns layout (see the @media blocks in index.css, which are
// true regardless of what any store thinks), and this owns BEHAVIOUR — the
// decisions CSS cannot express, like whether to mount the immersive overlay at
// all. Both agree on one number.

export const MOBILE_BREAKPOINT = 768;

/** Live viewport check. Never cached — that was the bug. */
export const isMobileViewport = (): boolean =>
  typeof window !== "undefined" && window.innerWidth <= MOBILE_BREAKPOINT;
